export default {
    wizardType: "GOOGLEANALYTICS",

    getConnectionParams: (type, model) => ({
        ClientId: model.get("clientId"),
        ClientSecret: model.get("clientSecret"),
        AccessToken: model.get("accessToken"),
        RefreshToken: model.get("refreshToken"),
        PropertyId: model.get("propertyId"),
        AutoTokenRenewal: model.get("autoTokenRenewal"),
    }),
};

